<template>
  <div>
    <PageTitle icon="fa fa-home" main="Unidades de Negócio" />
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="8">
              <b-input-group class="mt-1 mb-2">
                <b-form-input size="sm" v-model="search" type="text"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" @click="getData" variant="info">
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-button size="sm" @click="newRecord()" class="mt-1" style="float:right" variant="success">
                <i class="fas fa-plus"></i> Nova
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-table
                id="tbl"
                hover
                bordered
                resposive
                small
                striped
                head-variant="dark"
                primary-key="unidade_id"
                selectable
                select-mode="single"
                selected-variant="primary"
                show-empty
                empty-text="Sem dados para exibir"
                :per-page="pagination.perPage"
                :current-page="pagination.currentPage"
                :filter="search"
                :items="bus"
                :fields="fields"
                :busy="isBusy"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Carregando...</strong>
                  </div>
                </template>
                <template v-slot:cell(ind_ativo)="data">
                  <div class="text-center" v-if="data.item.ind_ativo === 0"><b-badge variant="danger">Não</b-badge></div>
                  <div class="text-center" v-else><b-badge variant="secondary">Sim</b-badge></div>
                </template>
                <template v-slot:cell(actions)="data">
                  <b-button size="sm" variant="success" @click="editRecord(data.item)">
                    <i class="fas fa-edit"></i>
                  </b-button>
                  <b-button size="sm" variant="danger" @click="deleteRecord(data.item)">
                    <i class="fas fa-trash"></i>
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="viewRecord(data.item)">
                    <i class="fas fa-search"></i>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group
                label="Exibir"
                label-cols-lg="4"
                label-for="pageSize"
                label-size="sm"
              >              
                <b-form-select size="sm" id="pageSize" v-model="pagination.perPage">
                  <b-form-select-option :value="8">8</b-form-select-option>
                  <b-form-select-option :value="20">20</b-form-select-option>
                  <b-form-select-option :value="50">50</b-form-select-option>
                  <b-form-select-option :value="0">Tudo</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-pagination
                class="float-right"
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="tbl"
              ></b-pagination>              
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- MODAL -->
    <ModalBU :bu="curRecord" :action="curAction" @updated="onUpdated" />
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle"
import ModalBU from './ModalBU'
import { baseApiUrl, showError } from "@/global"
import axios from "axios"
import { mapState } from "vuex"

export default {
  name: "BusinessUnit",
  components: { PageTitle, ModalBU },
  computed: mapState["user"],
  data: function() {
    return {
      pagination:{
        perPage: 8,
        totalRows: 0,
        currentPage: 1
      },
      search: '',
      isBusy: false,
      curAction: "view",
      bus: [],
      curRecord: {},
      fields: [
        { key: "unidade_id", label: "Código", sortable: true, 'class': 'w120-field' },
        { key: "descricao", label: "Descrição", sortable: true },
        { key: "ind_ativo", label: "Ativo?", sortable: true, 'class': 'w100-field' },
        { key: "actions", label: "Ações", 'class': 'w120-field' }
      ],
    };
  },
  methods: {
    onUpdated(){
      this.curAction = 'view'
      this.curRecord = {}
      this.getData()
    },
    editRecord(item) {
      this.curAction = "edit"
      this.curRecord = { ...item }
      this.$bvModal.show("modal-bu")
    },
    viewRecord(item) {
      this.curAction = "view"
      this.curRecord = { ...item }
      this.$bvModal.show("modal-bu")
    },
    newRecord() {
      this.curAction = "new";
      this.curRecord = {
        unidade_id: '',
        ind_ativo: 1,
      };
      this.$bvModal.show("modal-bu");
    },
    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir a Unidade ${item.unidade_id}?`, {
          noFade: true
        })
        .then(
          (yesno) => {
            if(yesno){
              this.isBusy = true
              axios.delete(`${baseApiUrl}/unidadesnegocio/${item.unidade_id}`, )
                .then(
                  () => this.getData()
                )
                .catch((err) => {
                  this.isBusy = false
                  showError(err)
                })
            }
          }
        )
        .catch(err => {
          showError(err)
          console.log(err);
        });
    },
    getData() {
      this.isBusy = true
      axios.get(`${baseApiUrl}/unidadesnegocio`)
        .then( (resp) =>
          { 
            this.isBusy = false
            this.bus = resp.data
            this.pagination.totalRows = this.bus.length
          }
        ).catch(
          (err) => {
            this.isBusy = false
            showError(err)
        })
    },
    colWidths(field) {
      let _width = "180px";

      if (field.key === "actions") _width = "130px";
      else if (field.key === "unidade_id") _width = "80px";

      return { width: _width };
    },
  },
  mounted() {
    this.getData()
  }
};
</script>

<style>
</style>